module.exports = __webpack_public_path__ + "img/history.af9f2bf.png";